module.exports = __webpack_public_path__ + "static/media/RationalDisplay-Medium.39a96d91.eot";